import { render, staticRenderFns } from "./AddContentToPublishersModal.vue?vue&type=template&id=66137ca8&lang=pug&"
import script from "./AddContentToPublishersModal.vue?vue&type=script&lang=js&"
export * from "./AddContentToPublishersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports